import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-policy-street-banner',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './policy-street-banner.component.html',
  styleUrl: './policy-street-banner.component.scss'
})
export class PolicyStreetBannerComponent {

}
